import { NgModule } from '@angular/core';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { MaintenanceRedirect } from './guards/maintenance-redirect';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'welcome'
      },
      {
        path: 'welcome',
        component: WelcomeComponent
      },
      {
        path: 'login',
        canActivate: mapToCanActivate([MaintenanceRedirect]),
        component: LoginComponent
      },
      {
        path: 'logout',
        canActivate: mapToCanActivate([MaintenanceRedirect]),
        component: LogoutComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [MaintenanceRedirect]
})
export class AppRoutingModule {}
